import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const applicationApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getApplications: builder.query({
            query: (arg) => {
                const query = queryGenerator(arg || {});
                return {
                    url: `application?${query}`,
                };
            },
            providesTags: ["Applications"],
        }),
        getApplication: builder.query({
            query: (id) => ({
                url: `application/${id?.id || id}`,
            }),
            providesTags: (result, error, arg) => [{ type: "Applications", id: arg?.id || arg }],
        }),
        addApplication: builder.mutation({
            query: (values) => ({
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `application`,
                body: values,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    await queryFulfilled;
                    toastHandler("Application added successfully", "success");
                } catch (err) {
                    const errorMessage = err?.error?.data?.error ||
                        err?.error?.data?.message ||
                        "Something went wrong, Please try again";
                    toastHandler(errorMessage, "warning");
                }
            },
            invalidatesTags: ["Applications", "Lead"],
        }),
        deleteApplication: builder.mutation({
            query: (id) => ({
                url: `application/${id?.id || id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    await queryFulfilled;
                    toastHandler("Application deleted successfully", "warning");
                } catch (err) {
                    toastHandler("Something went wrong", "warning");
                }
            },
            invalidatesTags: ["Applications", "Lead"],
        }),
        updateApplication: builder.mutation({
            query: ({ id, values }) => ({
                url: `application/${id}`,
                method: "PATCH",
                body: values,
            }),
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    await queryFulfilled;
                    toastHandler("Application updated successfully", "success");
                } catch (err) {
                    toastHandler("Failed to update application", "warning");
                }
            },
            invalidatesTags: ["Applications", "Lead"],
        }),
    }),
});

export const {
    useGetApplicationsQuery,
    useGetApplicationQuery,
    useAddApplicationMutation,
    useDeleteApplicationMutation,
    useUpdateApplicationMutation,
} = applicationApi;
